import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const storedCart = localStorage.getItem("cart");
    return storedCart ? JSON.parse(storedCart) : [];
  });

  // Load cart from localStorage on mount
  useEffect(() => {
    const storedCart = localStorage.getItem("cart");
    if (storedCart) setCart(JSON.parse(storedCart));
  }, []);

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    console.log('Cart updated:', cart);
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // Add item to cart
  const addToCart = (item) => {
    console.log('CartContext addToCart called with:', item);
    setCart((prev) => [...prev, item]);
  };

  const applyPeriodId = (periodId) => {
    if (!periodId) return;
    setCart((prev) => {
      let changed = false;
      const next = prev.map((item) => {
        if (item.periodId) return item;
        changed = true;
        return { ...item, periodId };
      });
      return changed ? next : prev;
    });
  };

  // Remove item from cart by id
  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  // Increment item quantity by id
  const incrementQuantity = (id) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: (item.quantity || 1) + 1 } : item
      )
    );
  };

  // Decrement quantity; never below 1 (removing the line is explicit via removeFromCart + confirm in UI).
  const decrementQuantity = (id) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              quantity: Math.max(1, (item.quantity || 1) - 1),
            }
          : item
      )
    );
  };

  // Clear cart
  const clearCart = () => setCart([]);

  // Sync cart across tabs
  useEffect(() => {
    const syncCart = (e) => {
      if (e.key === "cart") {
        setCart(JSON.parse(e.newValue) || []);
      }
    };
    window.addEventListener("storage", syncCart);
    return () => window.removeEventListener("storage", syncCart);
  }, []);

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart, incrementQuantity, decrementQuantity, applyPeriodId }}>
      {children}
    </CartContext.Provider>
  );
}; 